/* eslint-disable import/order */
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
import { getResolutionPlanSSRResource } from '@jira/router-resources__service-desk-ai-context-panel/src/ResolutionPlanSSRResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getQueuesResources,
	getKnowledgeBaseResources,
	getInsightResources,
	getIssueViewResources as getIssueViewResourcesServiceDesk,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPracticeIssueRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskPracticeIssueRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getDraftReplyPillsResource } from '@jira/router-resources__service-desk-draft-reply/src/getDraftReplyPillsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskQueuesIssueView, {
	LazyServicedeskQueuesIssueView,
} from './ui/issue-view/index.tsx';

export const servicedeskPracticeIssueRouteEntry: Route = createEntry(
	servicedeskPracticeIssueRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskQueuesIssueView,
		layout: composeLayouts(serviceProjectLayout, embeddedIssuePreloadLayoutBuilder()),

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getQueuesResources(),
			...getIssueViewResources(),
			...getKnowledgeBaseResources(),
			...getInsightResources(),
			getConsolidationStateResource(),
			...getAIContextPanelResources(),
			...getResolutionPlanSSRResource(),
			...getDraftReplyPillsResource(),
			...getIssueViewResourcesServiceDesk(),
		],

		afterPaint: [LazyIssueApp],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesIssueView],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
